import { READING_DARK_MODE_COOKIE, READING_DARK_MODE_COOKIE_BASE_OPTIONS, READING_HAS_LICENSE_COOKIE } from '#shared/cookies'

export const READING_DARK_MODE_COOKIE_OPTIONS = {
  ...READING_DARK_MODE_COOKIE_BASE_OPTIONS,
  default: () => false,
} as const
// Forced `colorMode: 'light'` takes precedence over user preference
const READING_ROUTE_PATTERNS = [
  /^\/lover-og-lovkommentarer\/.+/,
  /^\/faglitteratur\/bok\/.+/,
  /^\/faglitteratur\/artikkel\/.+/,
  /^\/tidsskrifter\/[^/]+\/[^/]+\/[^/]+(?:\/[^/]+)?$/,
  // /^\/maler\/.+/,
]

export const READING_DARK_MODE_BOOT_GATE =
  `(function(p,h){`
  + `if(p.length>1&&p.charAt(p.length-1)==='/'){p=p.slice(0,-1)}`
  + `if(h==='#om-boken'||p.slice(-9)==='/om-boken'){return false}`
  + `return [${READING_ROUTE_PATTERNS.map(String).join(',')}].some(function(r){return r.test(p)})`
  + `})`

export const READING_DARK_MODE_BOOT_SCRIPT =
  `(function(){try{`
  + `if(!${READING_DARK_MODE_BOOT_GATE}(location.pathname,location.hash)){return}`
  + `var m=document.cookie.match(/(?:^|; )${READING_DARK_MODE_COOKIE}=([^;]*)/);`
  + `var lm=document.cookie.match(/(?:^|; )${READING_HAS_LICENSE_COOKIE}=([^;]*)/);`
  + `var licensed=!!lm&&decodeURIComponent(lm[1])==='true';`
  + `var on=licensed&&!!m&&decodeURIComponent(m[1])==='true';`
  + `var el=document.documentElement;`
  + `el.classList.remove(on?'light-mode':'dark-mode');`
  + `el.classList.add(on?'dark-mode':'light-mode');`
  + `el.style.colorScheme=on?'dark':'light'`
  + `}catch(e){}})()`

export function isReadingRoute(path: string, hash = ''): boolean {
  if (hash === '#om-boken') {
    return false
  }

  const normalized = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
  if (normalized.endsWith('/om-boken')) {
    return false
  }

  return READING_ROUTE_PATTERNS.some(pattern => pattern.test(normalized))
}

export function resolveReadingPreference(path: string, hash: string, isDark: boolean): 'dark' | 'light' {
  return isReadingRoute(path, hash) && isDark ? 'dark' : 'light'
}
